import { render } from "./UploadRecording.vue?vue&type=template&id=4d493b4f&scoped=true"
import script from "./UploadRecording.vue?vue&type=script&lang=js"
export * from "./UploadRecording.vue?vue&type=script&lang=js"

import "./UploadRecording.vue?vue&type=style&index=0&id=4d493b4f&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d493b4f"]])

export default __exports__